__turbopack_context__.v({
  "userProfileFallbackContainer": "userProfileFallback-module-scss-module__0Pybla__userProfileFallbackContainer",
});
